import { useState, useEffect } from 'react';

export default function ScrollToTop() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 400);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (!isVisible) return null;

  return (
    <button
      onClick={scrollToTop}
      className="fixed bottom-8 right-8 z-40 w-11 h-11 flex items-center justify-center bg-primary-500 text-background-50 rounded-full hover:bg-primary-600 transition-all shadow-lg cursor-pointer"
      aria-label="回到顶部"
    >
      <div className="w-5 h-5 flex items-center justify-center">
        <i className="ri-arrow-up-line text-lg"></i>
      </div>
    </button>
  );
}